import React from "react";
import { Badge, IconButton, Tooltip, Typography } from "@mui/material";
import { Tune } from "@mui/icons-material";
import { useTranslation } from "react-i18next";
import {
  DASHBOARD2_SCHEDULE_FILTER_PANEL_ID,
  dashboard2FilterTriggerTouchTargetSx
} from "../dashboard2-status.styles";

type Dashboard2ScheduleFilterTriggerProps = {
  expanded: boolean;
  onToggle: () => void;
  selectedColleagueCount?: number;
  filterPanelId?: string;
};

export const Dashboard2ScheduleFilterTrigger: React.FC<Dashboard2ScheduleFilterTriggerProps> = ({
  expanded,
  onToggle,
  selectedColleagueCount,
  filterPanelId = DASHBOARD2_SCHEDULE_FILTER_PANEL_ID
}) => {
  const { t } = useTranslation();
  const expandLabel = t("_dashboard2_scheduleFilterExpand");
  const collapseLabel = t("_dashboard2_scheduleFilterCollapse");
  const ariaLabel = expanded ? collapseLabel : expandLabel;
  const badgeCount =
    selectedColleagueCount != null && selectedColleagueCount > 0
      ? selectedColleagueCount
      : undefined;

  return (
    <Tooltip title={<Typography>{ariaLabel}</Typography>}>
      <IconButton
        size="small"
        onClick={onToggle}
        aria-expanded={expanded}
        aria-controls={filterPanelId}
        aria-label={ariaLabel}
        sx={dashboard2FilterTriggerTouchTargetSx}
        data-testid="dashboard2-schedule-filter-trigger"
      >
        <Badge badgeContent={badgeCount} color="primary" max={99}>
          <Tune fontSize="small" />
        </Badge>
      </IconButton>
    </Tooltip>
  );
};
